import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UITextInput } from "components/ui";
import Classes from "model";
import React from "react";
import "./styles.css"
import { ImageAsset } from "res";

/**
 * @function SoftTokensActivateTokenRegisterCodePage
 * @return {React.Component}
 * @exported true
 * @description The main component for SoftTokensActivateTokenRegisterCodePage.
 */
export default function SoftTokensActivateTokenRegisterCodePage(props) { 
    const { nextStep } = useWorkflow() ?? {};
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
            .update([ "data", prop], { value: value })
            .submit(setState);
        },
        gotToNextStep: () => nextStep()
    });

    return (
        <PageContainer className="soft-tokens-activate-token-register-code-page" state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    );
}

export const getDefaultData = () => ({
    registrationCode: { value: "" },
    deviceNickname: { value: "" }
});

export const getDefaultUI = () => ({
    // no ui changes for now.
});

function PageContent() {
    const { gotToNextStep, onChange, data } = useStateManager();

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Activate Token" />
                <p className="subtitle text-section">Instructions</p>

                <div className="instructions-container">
                    <p>1. Activate DIGIPASS on your mobile device.</p>
                    <p>2. Follow the directions on your mobile device to activate a DIGIPASS.</p>
                    <p>3. Scan the image presented below. This is known as a Cronto image.</p>
                    <p>4. If requested, follow directions on your phone to create a PIN. You will need the PIN every time you need to request an authentication code.</p>
                    <p>5. The app will return a registration code. Enter the registration code below.</p>
                    <p>6. Create a nickname for your device.</p>
                </div>

                <p className="text-section">Scan the image presented below, and press "Register".</p>

                <div className="flex-container flex-horizontal qr-code-container">
                    <div className="flex-container flex-vertical align-center">
                        <ImageAsset id="DigiPassQRCodeIcon" className="qr-code-image" data-point="Soft_Tokens_Activate_Token_Register_Code_Page_Digi_Pass_QR_Code_Icon" />
                    </div>
                </div>
                
                <FormContainer className="small-form-width">
                    <FormRowView text={`Enter the Registration Code provided by the DIGIPASS app.`} />
                    <FormRowView className="set-width" text="* Registration Code">
                        <UITextInput value={ data.registrationCode.value } 
                        dataPoint="Soft_Tokens_Activate_Token_Register_Code_Page_Registration_Code_Input" onChange={ onChange("registrationCode") } />
                    </FormRowView>
                    <FormRowView text={`Please enter a descriptive name to identify your mobile device.`} />
                    <FormRowView className="set-width" text="* Device Nickname">
                        <UITextInput value={ data.deviceNickname.value }
                        dataPoint="Soft_Tokens_Activate_Token_Register_Code_Page_Device_Name_Input" onChange={ onChange("deviceNickname") } />
                    </FormRowView>
                    <FormButtonRow>
                        <UIButton className="secondary-button" text="Cancel" dataPoint="Soft_Tokens_Activate_Token_Register_Code_Page_Cancel_Button" />
                        <UIButton className="primary-button" text="Register" dataPoint="Soft_Tokens_Activate_Token_Register_Code_Page_Register_Button" onClick={ gotToNextStep } />
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    );
}
